<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M56.153 14.616a16.747 16.747 0 0 0-17.106 0l-15.498 9.178c-5.277 3.125-8.482 8.866-8.482 15.028v18.356c0 6.162 3.205 11.903 8.482 15.028l5.932 3.513 5.45-5.45-7.578-4.487c-2.954-1.75-4.82-5.017-4.82-8.604V38.822c0-3.587 1.866-6.854 4.82-8.604l15.498-9.178a9.28 9.28 0 0 1 9.498 0l15.498 9.178c2.954 1.75 4.82 5.018 4.82 8.604v18.356c0 3.587-1.866 6.854-4.82 8.604l-.133.079-.126.089-.002.001-.022.015-.1.07a59.297 59.297 0 0 1-1.978 1.299 59.962 59.962 0 0 1-5.213 2.938l5.533 5.533a71.008 71.008 0 0 0 5.911-3.633l.065-.045c5.2-3.142 8.351-8.839 8.351-14.95V38.822c0-6.163-3.205-11.903-8.482-15.029l-15.498-9.177Z"
        fill="currentColor"
      />
      <path
        d="M56.133 76.8 47.6 85.333l-4.58-4.57-3.953-3.963 8.533-8.533 8.533 8.533Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.6 38.22a3.378 3.378 0 0 0-3.378 3.379 3.733 3.733 0 1 1-7.467 0c0-5.99 4.855-10.845 10.845-10.845 5.989 0 10.844 4.855 10.844 10.845 0 2.153-.631 4.17-1.72 5.863-.649 1.007-1.4 1.958-2.063 2.783l-.364.451c-.55.68-1.034 1.28-1.483 1.897-1.119 1.538-1.481 2.493-1.481 3.228v1.778a3.733 3.733 0 1 1-7.467 0V55.82c0-3.193 1.568-5.776 2.91-7.62a56.487 56.487 0 0 1 1.75-2.244l.318-.393c.657-.818 1.186-1.499 1.6-2.143a3.378 3.378 0 0 0-2.845-5.2Z"
        fill="currentColor"
      />
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
